module.exports = __webpack_public_path__ + "img/caiwu.e4c32194.png";